import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';

const SellPage = lazy(() => import('./SellPage'));
const PaymentPage = lazy(() => import('./PaymentPage'));
const SuccessPage = lazy(() => import('./SuccessPage'));

const S = ({ children }: { children: ReactNode }) => <Suspense fallback={<PageLoader />}>{children}</Suspense>;

export const routes: RouteObject[] = [
  {
    path: 'vender',
    element: <S><SellPage /></S>,
    // /vender/carrinho abre o carrinho em folha sobre os produtos (celular). A tela de produtos
    // continua montada: o botão "voltar" do aparelho fecha a folha sem perder busca e rolagem.
    children: [{ path: 'carrinho', element: null }],
  },
];

/** Pagamento e conclusão ocupam a tela toda (sem menu lateral). */
export const fullscreenRoutes: RouteObject[] = [
  { path: 'vender/pagamento', element: <S><PaymentPage /></S> },
  { path: 'vender/concluido/:id', element: <S><SuccessPage /></S> },
];
